import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import InviteAccept from "@/pages/InviteAccept";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import Account from "@/pages/Account";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";
import HelpCentre from "@/pages/HelpCentre";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import PublicApplication from "@/pages/PublicApplication";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import XeroCallback from "@/pages/XeroCallback";
import Contact from "@/pages/legal/Contact";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Subprocessors from "@/pages/legal/Subprocessors";
import Accessibility from "@/pages/legal/Accessibility";
import Comparison from "@/pages/Comparison";
import TradeLanding from "@/pages/TradeLanding";
import AiTakeoff from "@/pages/AiTakeoff";
import Roi from "@/pages/Roi";
import CookieBanner from "@/components/CookieBanner";
import Analytics from "@/components/Analytics";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Analytics />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/invite/:token" element={<InviteAccept />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/settings/xero/callback" element={<ProtectedRoute><XeroCallback /></ProtectedRoute>} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/pay/:token" element={<PublicApplication />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/subprocessors" element={<Subprocessors />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/vs/:slug" element={<Comparison />} />
              <Route path="/ai-takeoff" element={<AiTakeoff />} />
              <Route path="/roi" element={<Roi />} />
              <Route path="/electrical-estimating-software" element={<TradeLanding slug="electrical" />} />
              <Route path="/plumbing-estimating-software" element={<TradeLanding slug="plumbing" />} />
              <Route path="/groundworks-estimating-software" element={<TradeLanding slug="groundworks" />} />
              <Route path="/carpentry-estimating-software" element={<TradeLanding slug="carpentry" />} />
              <Route path="/plastering-estimating-software" element={<TradeLanding slug="plastering" />} />
              <Route path="/painting-estimating-software" element={<TradeLanding slug="painting" />} />
              <Route path="/flooring-estimating-software" element={<TradeLanding slug="flooring" />} />
              <Route path="/brickwork-estimating-software" element={<TradeLanding slug="brickwork" />} />
              <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/app/project/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
              <Route path="/app/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
              <Route path="/app/insights" element={<ProtectedRoute><Insights /></ProtectedRoute>} />
              <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/app/help" element={<ProtectedRoute><HelpCentre /></ProtectedRoute>} />
            </Routes>
            <CookieBanner />
            <InstallPrompt />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
